<template>
    <div>
        <Modal
            v-model="visible"
            title="查看清单"
            :closable="true"
            :mask-closable="false"
            width="1100"
            :footer-hide="true"
            class="my-modal top import-tool-modal2 p-b"
        >
            <div class="table-box">
                <loading :isShow="listLoading" />
                <Table :columns="personnelColumns" :data="personnelTableData">
                  <template slot-scope="{ row }" slot="cardNoMask">
                    <div>
                      <span v-if="!row.eyeShow1">{{ row.cardNoMask }}</span>
                      <span v-else>{{ row.cardNoMask1 }}</span>
                      <span v-if="row.cardNoMask">
                        <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow1" @click="openEye(row, 'eyeShow1', 'cardNoMask')"></i>
                        <i class="iconfont iconyincang eye-icon" v-else @click="openEye(row, 'eyeShow1', 'cardNoMask')"></i>
                      </span>
                    </div>
                  </template>
                    <template slot-scope="{ row }" slot="action">
                        <div>
                            <span class="table-btn" @click="deletePersonnelList(row)">删除</span>
                        </div>
                    </template>
                </Table>
            </div>
            <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center" />
        </Modal>
    </div>
</template>

<script>
let typeMap = {
    1: '增保',
    2: '替保',
    3: '减保'
};
import filter from "@/api/filter";
import { pageTool, common } from '@/api/mixins';
export default {
    mixins: [pageTool,common],
    data() {
        return {
            policyNo: '',
            id:'',
            visible: false,
            listLoading: false,
            total: 0,
            pageNum: 1,
            pageSize: 10,
            personnelTableData: [],
            personnelColumns: [
                {
                    title: '姓名',
                    key: 'name',
                    minWidth: 100,
                    align: 'center'
                },
                {
                    title: '证件号',
                    slot: 'cardNoMask',
                    minWidth: 180,
                    align: 'center',
                  
                },
                {
                    title: '证件类型',
                    key: 'cardType',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        let cardType = params.row.cardType;
                        return <span>{ cardType?filter.filterCardType(cardType) : '-' }</span>
                    },
                },
                {
                    title: '保全类型',
                    key: 'endorsementType',
                    minWidth: 100,
                    align: 'center',
                    render(h, params) {
                        return <span> {typeMap[params.row.endorsementType]}</span>;
                    }
                },
                {
                    title: '职业类别',
                    key: 'jobGrade',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        const jobGrade = params.row.jobGrade;
                        return <span>{jobGrade ? jobGrade : '-'}</span>;
                    }
                },
                {
                    title: '保障计划',
                    key: 'planName',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        const planName = params.row.planName;
                        return <span>{planName ? planName : '-'}</span>;
                    }
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: '100',
                    fixed: 'right'
                }
            ]
        };
    },

    methods: {
      openEye(item,keyName,name){
        if (!item[keyName]) {
          this.descrypt(
            {
              query: item.id,
              operationFunction: 19,
              operationType: 1
            },
            item,
            name + '1',
            'order_50_1'
          ).then(() => {
            this.$set(item, keyName, true);
          });
        } else {
          this.$set(item, keyName, false);
        }
      },
        open(policyNo, id) {
            this.policyNo = policyNo;
            this.id = id;
            this.visible = true;
            this.getPersonneList();
        },

        getPersonneList() {
            this.listLoading = true;
            this.$http({
                url: '/buz/grouppolicy/page/insures',
                type: 'POST',
                data: {
                    pageSize: this.pageSize,
                    pageNo: this.pageNum,
                    policyNo: this.policyNo,
                    endorsementId: this.id
                }
            })
                .then(res => {
                    this.listLoading = false;
                    this.personnelTableData = res.data;
                    this.total = res.total;
                })
                .catch(e => {
                    this.listLoading = false;
                });
        },

        deletePersonnelList(row) {
            this.$Modal.confirm({
                title: '确定删除吗？',
                onOk: () => {
                    this.$http({
                        url: `/buz/grouppolicy/enter/insures/delete`,
                        type: 'GET',
                        data: {
                            id: row.id
                        }
                    }).then(res => {
                        this.$notice.success('删除成功');
                        this.getPersonneList();
                    });
                },
                onCancel: () => {}
            });
        },

        //分页切换页码
        pageChange(pageNum) {
            this.pageNum = pageNum;
            this.getPersonneList();
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/.table-box {
    margin-top: 15px;
}
.eye-icon {
    cursor: pointer;
    margin-left: 5px;
  }
</style>
